export default __webpack_public_path__ + "static/media/bg7.4e59966a.svg";